import {Utils} from "../reusable/Utils";

export class RecipeParser {

    parseFormData(formData: any) {
        return {
            name: formData.name,
            description: formData.description,
            height: {
                value: formData.height,
                unit: formData.heightUnit
            },
            diameter: {
                value: formData.diameter,
                unit: formData.diameterUnit
            },
            mass: {
                value: formData.mass,
                unit: formData.massUnit
            },
            ingredients : this.recipeIngredientsFromFormData(formData)
        }
    }

    private recipeIngredientsFromFormData(formData: any) {
        const names = Utils.filterSimilarObjectProps(formData, "ingredient-name-")
        const masses = Utils.filterSimilarObjectProps(formData, "ingredient-mass-")
        const units = Utils.filterSimilarObjectProps(formData, "ingredient-unit-")

        if (names.length !== masses.length || names.length !== units.length || masses.length !== units.length) {
            //TODO: implement proper error handling
            console.log("ERROR, ENTRIES HAVE NOT SAME AMOUNT")
        }

        const ingredients: RecipeIngredient[] = []
        for (let i = 0; i < names.length; i++) {
            ingredients.push({
                name: names[i] as string,
                mass: {
                    value: masses[i] as number,
                    unit: units[i] as MassUnit
                }
            })
        }
        return ingredients
    }

    parseRecipe(recipe: Recipe) {
        const formData: any = {
            name: recipe.name,
            description: recipe.description,
            mass: recipe.mass?.value ?? 0,
            massUnit: recipe.mass?.unit ?? "g",
            diameter: recipe.diameter?.value ?? 0,
            diameterUnit: recipe.diameter?.unit ?? "cm",
            height: recipe.height?.value ?? 0,
            heightUnit: recipe.height?.unit ?? "cm",
        }

        recipe.ingredients.forEach((ingredient, index) => {
            const name = "ingredient-name-" + index
            const mass = "ingredient-mass-" + index
            const unit = "ingredient-unit-" + index
            formData[name] = ingredient.name
            formData[mass] = ingredient.mass.value
            formData[unit] = ingredient.mass.unit
        })

        return formData
    }
}
